export const ADD_RECENT_VIEWED = 'ADD_RECENT_VIEWED' as const;
export const addToRecentViewed = (jobName: string) => ({
  type: ADD_RECENT_VIEWED,
  payload: { jobName },
});

export type RecentViewedAction = ReturnType<typeof addToRecentViewed>;
